/*
 * File: FeedAction.jsx
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 4, 2022 at 4:30 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 10:40 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Components
import { Typography } from '../Typography';

// Styles
import * as S from './FeedAction.styles';


/**
 * Component
 */

export const FeedAction = ({
	className, title, isOpen, titleDecoration, onClick
}) => {

	// Handle actions on component load
	useEffect(() => {}, []);

	// Render component
	return (
		<S.ActionButton onClick={onClick} className={className ? `${className} animate` : 'animate'} $isOpen={isOpen}>
			<Typography variation="button-small" weight="medium">{title}</Typography>
			{titleDecoration}
			<FontAwesomeIcon className="animate" icon={['far', 'angle-down']} />
		</S.ActionButton>
	);
};


/**
 * Configuration
 */

FeedAction.displayName = 'FeedAction';
FeedAction.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string,
	isOpen: PropTypes.bool,
	onClick: PropTypes.func,
	titleDecoration: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
FeedAction.defaultProps = {
	className: null,
	title: null,
	isOpen: false,
	onClick: null,
	titleDecoration: null
};
